<template>
     <!-- navbar -->
     <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">
        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->
        <img :src="'/imgs/tallyLogo4.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Pricing
                        </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Faq's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Support</a>
                </li>
            </ul>
        </div> 

        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <div class="flex justify-between mr-4">
              <div class="flex justify-between space-x-2">
                <img :src="'/imgs/tally_header.png'" class="img-fluid " alt="" >
                  <div class="flex flex-col ml-2">
                    <div>
                      <h6 class=" text-xs font-semibold text-gray-400" >
                          hotline 24/7
                      </h6>
                    </div>
                  <div>
                    <h6 class=" text-xs text-gray-700 font-bold">
                        (+91)9263637575
                    </h6>
                  </div>
                          
                </div>
              </div>
              </div> 
            </ul>
             <button type="button" id="button" class=" md:py-1 py-1 mr-2 px-3 rounded-md  text-white" style="background-color: #07528E;">Get Free</button>     
        </div> 
  </nav>
    <!-- navbar -->  
 <!-- banner start -->
 <section>
   <div class="rectangle py-1">
           <div class="container">
           <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4  ">
           <div class="mt-5">
              <h2 class="font-bold text-white mt-5">Connecting The World to <span style="color:#F5AB0F">Tally</span><span style="color:#87BBE0">Clinic?</span></h2> 
               <!-- Another variation with a button -->
              
             <p class="mt-5 font-semibold text-white">The easy way to send,receive,store and trade digital currencies</p>
           </div>
           <!-- ... -->
           <div>
              <img :src="'/imgs/addons_banner3.png'" class="img-fluid banner" alt="" >
           </div>
           </div>
          </div>      
   </div>
 </section>
 <!-- banner end -->

 <!-- second section -->
<!-- for display view -->
 <section>
   <div class="sec_rectangle py-4">
    <div class="container">
           <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4  ">
            <div>
               <img :src="'/imgs/addons_Detail3.jpg'" class="img-fluid banner1" alt="" >
           </div>
           <div class="mt-5">
              <h2 class="font-bold ">Managing your finance with us is a tap away</h2> 
               <!-- Another variation with a button -->
              
             <p class="mt-5 font-bold ">Suggestions: <span style="color:#07528E" class="font:bold"> Data Structure, Descreate Mathematics</span></p>
           </div>
           <!-- ... -->
          
           </div>
    </div>
       
   </div>
 </section>
   <!-- for mobile view -->
 <section>
  <div class="sec_rect py-4">
    <div class="container">
      <div class="mt-5">
              <h2 class="font-bold ">Managing your finance with us is a tap away</h2> 
               <!-- Another variation with a button -->
              
             <p class="mt-5 font-bold ">Suggestions: <span style="color:#07528E" class="font:bold"> Data Structure, Descreate Mathematics</span></p>
        </div>

        <div>
               <img :src="'/imgs/addons_Detail3.jpg'" class="img-fluid banner1" alt="" >
        </div>  

    </div>
  </div>   
 </section>
 <!-- second section end -->

 <!-- third section start from here -->
 <section class="py-4 third_rec">
  <div class="container">

    <div>
    <div class="text-left">
        <h2 class="font-bold" style="color:#F5AB0F">Make Product changes once</h2>
    </div>

    <div class="mt-10 sm:mt-4">
      <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 md:col-gap-8 md:row-gap-10">   
        <li class="my-10 md:mt-0">
          <div class="flex flex-col justify-center items-center">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center  rounded-md text-indigo-500">
                <img :src="'/imgs/addons_icon1.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="mt-2 text-center">
              <h4 class="text-lg leading-6 font-medium">Feature Name</h4>
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. </p>
            </div>
          </div>
        </li>
        <li class="my-10 md:mt-0">
          <div class="flex flex-col justify-center items-center">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon2.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="mt-2 text-center">
              <h4 class="text-lg leading-6 font-medium ">Feature Name</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
        </li>
        <li class="my-10 md:mt-0">
          <div class="flex flex-col justify-center items-center">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon3.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="mt-2 text-center">
              <h4 class="text-lg leading-6 font-medium ">Feature Name</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
        </li>
        <li class="my-10 md:mt-0">
          <div class="flex flex-col justify-center items-center">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon4.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="mt-2 text-center">
              <h4 class="text-lg leading-6 font-medium ">Feature Name</h4>
              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
            </div>
          </div>
        </li>    
      </ul>
    </div>
    </div>

   

  </div>
</section>
 <!-- third section end  -->

 <!-- Fourth section start from here -->
<section>
    <div class="py-4 fourth_rec">
        <div class="container">
            <div class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
            <div class="mt-3">
                <h2 class="font-bold" style="color:#F5AB0F">Start Improving your Business Today</h2>
                <p class="mt-4 font-medium text-base">Simple Landing Page. Inspirational designs, illustrations, and graphic elements from the world's best designers.
                </p>
            </div>
            
            <div class="col-span-2 ">

            <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4">
                <div class="my-3 md:mt-0">
          <div class="flex">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon5.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="ml-2">
              <h4 class="text-lg leading-6 font-medium text-gray-900">Feature Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
                </div>
                <div class="my-3 md:mt-0">
          <div class="flex">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon5.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="ml-2">
              <h4 class="text-lg leading-6 font-medium text-gray-900">Feature Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
                </div>
                <div class="my-3 md:mt-0">
          <div class="flex">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon5.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="ml-2">
              <h4 class="text-lg leading-6 font-medium text-gray-900">Feature Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
                </div>
                <div class="my-3 md:mt-0">
          <div class="flex">
            <div class="flex-shrink-0">
              <div class="flex items-center justify-center ">
                <img :src="'/imgs/addons_icon5.png'" class="img-fluid " alt="" >
              </div>
            </div>
            <div class="ml-2">
              <h4 class="text-lg leading-6 font-medium text-gray-900">Feature Name</h4>
              <p class=" text-sm text-gray-500">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </p>
            </div>
          </div>
                </div>
           </div>
            </div>
            </div>

    <div class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 mt-5 ">
    <div class="border px-5 py-3 ">
      <img :src="'/imgs/img16.png'" class="img-fluid " alt="" > 
 
    </div>
   
    <div class="col-span-2  six_rec border px-5 py-3 ">
       <h4>People Illustrations to download for free </h4>
       <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis libero fuga porro distinctio. Ipsum voluptate rerum quo, velit quis nulla pariatur optio cum ab quod a, corrupti repellendus! Aut fuga assumenda ipsum.</p>
    </div>
    </div>
    </div>
    </div>
</section>
 <!-- fourth section end -->

 <!-- sixth section start -->
 <div class="py-4">
    <div class="container max-w-screen-xl">
      <div class="row justify-content-center mb-10">
        <div class="col-12 col-md-10 col-lg-6 text-center">
          <!-- Heading -->
          <h1 class="ls-tight font-bolder h3 lh-tight">
            Over 50k developers are using our theme
          </h1>
          <!-- Text -->
          <p class="lead text-muted mt-3">
            Start building fast, beautiful and modern looking websites in no time.
          </p>
        </div>
      </div>
      <!-- Clients -->
      <div class="grid grid-cols-6 gap-4">
  <div>
    <img :src="'/imgs/amazon.png'" class="img-fluid " alt="" >
  </div>
  <!-- ... -->
  <div>
    <img :src="'/imgs/spotify.png'" class="img-fluid " alt="" >
  </div>
    <!-- ... -->
    <div>
      <img :src="'/imgs/paypal.png'" class="img-fluid " alt="" >
    </div>
      <!-- ... -->
  <div>
    <img :src="'/imgs/google.png'" class="img-fluid " alt="" >
  </div>
    <!-- ... -->
    <div>
      <img :src="'/imgs/slack.png'" class="img-fluid " alt="" >
    </div>
      <!-- ... -->
  <div>
    <img :src="'/imgs/airbnb.png'" class="img-fluid " alt="" >
  </div>
</div>
      
    </div>
  </div>
  <div class=" Py-5">
    <div class="container ">
       <!-- 1st step display start -->
      <div class="section-step-lg py-5 dp_view">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6">
            <div class="rounded shadow-4 bg-surface-primary border p-2 me-lg-5 position-relative">
              <img :src="'/imgs/screen1.png'" class="img-fluid banner" alt="" >
              <!-- <img alt="..." src="imgs/screen1.png" class="img-fluid rounded"> -->
            </div>
          </div>
          <div class="col-lg-5 md:col-lg-12 mb-7 mb-lg-0 ">
            <!-- Surtitle -->
            <h3 class=" mb-2 text-uppercase font-semibold" style="color:#07528E">
              Step 1
            </h3>
            <!-- Heading -->
            <h4 class=" font-semibold mb-2" style="color:#f5ab0f">
              Need a quick admin panel for your website?
            </h4>
            <!-- Text -->
            <p class=" font-semibold">
              Components and examples, including tons of variables that will help you customize this theme with ease.
            </p>
            <!-- List -->
            <ul class="list-unstyled mt-2 mb-0 text-sm">
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Perfect for modern startups</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Ready to be customized</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Designed for every devices</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 1st step display start -->
      <!-- 1st step mobile view start -->
      <div class="section-step-lg  py-5  mb_view">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-7 mb-lg-0 ">
            <!-- Surtitle -->
            <h3 class=" mb-2 text-uppercase font-semibold" style="color:#07528E">
              Step 1
            </h3>
            <!-- Heading -->
            <h4 class=" font-semibold mb-2" style="color:#f5ab0f">
              Need a quick admin panel for your website?
            </h4>
            <!-- Text -->
            <p class=" font-semibold">
              Components and examples, including tons of variables that will help you customize this theme with ease.
            </p>
            <!-- List -->
            <ul class="list-unstyled mt-2 mb-0 text-sm">
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Perfect for modern startups</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Ready to be customized</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Designed for every devices</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-lg-6">
            <div class="rounded shadow-4 bg-surface-primary border p-2 me-lg-5 position-relative">
              <img :src="'/imgs/screen1.png'" class="img-fluid banner" alt="" >
              <!-- <img alt="..." src="imgs/screen1.png" class="img-fluid rounded"> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 1st mobile step end -->
      <!-- 2nd display step start -->
      <div class="section-step-lg ">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-7 mb-lg-0 ">
            <!-- Surtitle -->
            <h3 class=" mb-2 text-uppercase font-semibold"  style="color:#07528E">
              Step 2
            </h3>
            <!-- Heading -->
            <h4 class=" font-semibold mb-2"  style="color:#f5ab0f">
              No limits regarding customization 
            </h4>
            <!-- Text -->
            <p class=" font-semibold">
              Components and examples, including tons of variables that will help you customize this theme with ease.
            </p>
            <!-- List -->
            <ul class="list-unstyled mt-2 mb-0 text-sm">
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Perfect for modern startups</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Ready to be customized</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Designed for every devices</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-lg-6">
            <div class="rounded shadow-4 bg-surface-primary border p-2 me-lg-5 position-relative">
              <img :src="'/imgs/screen2.png'" class="img-fluid banner" alt="" >
            </div>
          </div>
        </div>
      </div>
      <!-- 2nd display step end -->
       <!-- 3rd display step start -->
      <div class="section-step-lg py-5 dp-view">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-6">
            <div class="rounded shadow-4 bg-surface-primary border p-2 me-lg-5 position-relative">
              <img :src="'/imgs/screen3.png'" class="img-fluid banner" alt="" >
            </div>
          </div>
          <div class="col-lg-5 mb-7 mb-lg-0 ">
            <!-- Surtitle -->
            <h3 class=" mb-2 text-uppercase font-semibold" style="color:#07528E">
              Step 3
            </h3>
            <!-- Heading -->
            <h4 class=" font-semibold mb-2" style="color:#f5ab0f">
              Use it with your favorite technologies 
            </h4>
            <!-- Text -->
            <p class=" font-semibold">
              Components and examples, including tons of variables that will help you customize this theme with ease.
            </p>
            <!-- List -->
            <ul class="list-unstyled mt-2 mb-0 text-sm">
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0  text-gray-500">Perfect for modern startups</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Ready to be customized</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Designed for every devices</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 3rd display step end -->
      <!-- 3rd step mobile view start -->
      <div class="section-step-lg  py-5  mb_view">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-7 mb-lg-0 ">
            <!-- Surtitle -->
            <h3 class=" mb-2 text-uppercase font-semibold" style="color:#07528E">
              Step 3
            </h3>
            <!-- Heading -->
            <h4 class=" font-semibold mb-2" style="color:#f5ab0f">
              Use it with your favorite technologies 
            </h4>
            <!-- Text -->
            <p class=" font-semibold">
              Components and examples, including tons of variables that will help you customize this theme with ease.
            </p>
            <!-- List -->
            <ul class="list-unstyled mt-2 mb-0 text-sm">
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0  text-gray-500">Perfect for modern startups</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Ready to be customized</span>
                  </div>
                </div>
              </li>
              <li class="py-1">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="icon icon-xs icon-shape bg-success text-white text-base rounded-circle me-3">
                      <i class="bi bi-check"></i>
                    </div>
                  </div>
                  <div>
                    <span class="h6 font-semibold mb-0 text-gray-500">Designed for every devices</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-lg-6">
            <div class="rounded shadow-4 bg-surface-primary border p-2 me-lg-5 position-relative">
              <img :src="'/imgs/screen3.png'" class="img-fluid banner" alt="" >
              <!-- <img alt="..." src="imgs/screen1.png" class="img-fluid rounded"> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 3rd mobile step end -->
    </div>
  </div>
 <!-- sixth section end -->
 
 <!-- faq's section -->
 <section class="faq">
 <div class="container">
 <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-3 ">
 
  <div >
     <section>
     
        <img :src="'/imgs/tally_fq.png'" class="img-fluid" alt="" >
        <div class="py-3">
         <div class="container">
            <h2 class="font-bold" style="color:#F5AB0F">FAQ'S</h2>
  
  <ul class="accordion">
      <li>
          <a>Lorem ipsum</a>
          <p >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit, ipsum, fuga, in, obcaecati voluptatibus eos at perferendis repellat odit aliquid harum molestias ratione pariatur adipisci. Aliquid, iure.</p>
      </li>
      <li>
          <a class="py-2">Repellat Odit Aliquid</a>
          <p>Lorem ipsum dolor sit amet, quas tempora maxime rerum neque deserunt suscipit provident cumque et mollitia sapiente voluptatibus eos at perferendis repellat odit aliquid harum molestias ratione pariatur adipisci. Aliquid, iure.</p>
      </li>
      <li>
          <a class="py-2">Dolor sit Amet</a>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit, ipsum, fuga, in, obcaecati voluptatibus eos at perferendis repellat odit aliquid harum molestias ratione pariatur adipisci. Aliquid, iure.</p>
      </li>
    <li>
          <a class="py-2">Repellat Odit Aliquid</a>
          <p>Lorem ipsum dolor sit amet, quas tempora maxime rerum neque deserunt suscipit provident cumque et mollitia sapiente voluptatibus eos at perferendis repellat odit aliquid harum molestias ratione pariatur adipisci. Aliquid, iure.</p>
      </li>
      <li>
          <a class="py-2">Dolor sit Amet</a>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit, ipsum, fuga, in, obcaecati voluptatibus eos at perferendis repellat odit aliquid harum molestias ratione pariatur adipisci. Aliquid, iure.</p>
      </li>
  </ul> 
  
                    <div class="flex -mt-4 space-x-2">
                        <h6 class="text-gray-700 ">
                            SEE MORE
                          </h6>
                          <i class="fas fa-chevron-right ml-3"></i>
                    </div>
        </div>
      </div>
     </section>
  </div>
  <div class="my-5 mx-4">
    <img :src="'/imgs/tally_dtl_faq.png'" class="img-fluid " alt="" >
  </div>
</div>
</div>
 </section>
<!-- faq's section end -->

 <!-- footer start -->
   <div>
        <footer class="section bg-footer section-main-container">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Get our app</h6>
  
                          <div class="">
                              <a href=""><img
                                      src="/imgs/gp.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                              <a href=""> <img
                                      src="/imgs/gp2.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Resources</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-2">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Help</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-4">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                          <table>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-envelope contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; abc@aruvaa.com</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-mobile-alt contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; +01 123-456-7890</p>
                                  </td>
                              </tr>
                          </table>
  
   </div>
                  </div>
  
              </div>
          </div>
  
          <div class="text-center mt-5 container">
              <hr class="footer-hr">
              <div class="d-flex justify-content-center below-hr-container">
                  <a href=""><span>Privary Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Terms of use</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Cookie Privacy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Abuse Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Anti-spam Policy</span></a>
              </div>
              <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
          </div>
      </footer>
    </div>
    <!-- footer end -->
<!-- footer end -->
</template>

<script>
  export default {
   mounted(){
    // faq's
  (function($) {
      $('.accordion > li:eq(0) a').addClass('active').next().slideDown();
  
      $('.accordion a').click(function(j) {
          var dropDown = $(this).closest('li').find('p');
  
          $(this).closest('.accordion').find('p').not(dropDown).slideUp();
  
          if ($(this).hasClass('active')) {
              $(this).removeClass('active');
          } else {
              $(this).closest('.accordion').find('a.active').removeClass('active');
              $(this).addClass('active');
          }
  
          dropDown.stop(false, true).slideToggle();
  
          j.preventDefault();
      });
  })(jQuery);
   }
  }
</script>

<style>
* {
  outline: none;
}
h6{
margin-bottom: 0.1rem;
}
.navbar {
  position: relative;
  display: flex;
  align-items: center; 
  padding: .5rem 5rem;
}
.img_size{
 height: auto;
 width: 156px;
}
.nav-link-header {
     color: #9c761f !important;
     font-weight: 650 !important;
     font-size: 16px;
 }
 .rectangle{
   background-color:#07528E;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
 }

.banner{
  height: auto;
 width: 556px; 
}

/* second section css */
.sec_rectangle{
   background-color:white;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
 }

 .banner1{
  height: auto;
 width: 456px; 
}

/* third section stat */
.third_rec{
    background-color:#F0EFF5;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
}

/* fourth section  css start */
.fourth_rec{
    background-color:white;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
}
.fifth_rec{
  background-color:#07528E;
   /* height: 60vh; */
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
}
.six_rec{
  background-color:#F5F8FE; 
}
.faq{
  background-color:#F0EFF5; 
}
/* footer css start */
.bg-footer {
          background-color: #33383c;
          padding: 50px 0 30px;
      }
      .footer-heading {
          letter-spacing: 2px;
      }
      .footer-link a {
          color: #ffffff;
          font-size: 14px;
          transition: all 0.2s;
          text-decoration: none;
      }
      .footer-link a:hover {
          color: #FDC031;
          text-decoration: none;
      }
      .contact-info {
          color: #ffffff;
          font-size: 14px;
      }
      .footer-alt {
          color: #818282;
          font-size: 12px;
      }
      .footer-heading {
          position: relative;
          padding-bottom: -12px !important;
      }
      .footer-heading:after {
          content: '';
          width: 25px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
      }
      .contact-info-icon {
          color: #ffffff;
          font-size: 16px;
      }
      .contact-info-data {
          color: #ffffff;
          font-size: 16px;
          margin: 0px 0px 0px !important;
      }
      /* Extra small devices (phones, 600px and down) */
      @media  only screen and (max-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }
         
        
      }
      /* Small devices (portrait tablets and large phones, 600px and up) */
      @media  only screen and (min-width: 600px) {
          .footer-download-icon {
              width: 36%;
          }
          .carousel-content {
   
    transition: width .4s;
    height: 80%;
  }
  
      }

      @media  only screen and (max-width: 758px) {
        .sec_rectangle{
        display: none;
    }  
    .dp-view{
      display: none;
    }
    .navbar {
  padding: .5rem 1rem;
}
      }
      @media only screen and (max-width: 992px) {
    .navbar {
  padding: .5rem 1rem;
}
  }
      @media  only screen and (min-width: 758px) {
        .sec_rect{
       display: none; 
    } 
    .mb_view{
      display: none;
    }
    
      }
      /* Medium devices (landscape tablets, 768px and up) */
      @media  only screen and (min-width: 768px) {
          .footer-download-icon {
              width: 40%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
      .sec_rect{
    display: none;
    } 
        .mb_view{
      display: none;
    }      
      }
      @media  only screen and (max-width: 768px) {
        .sec_rectangle{
        display: none;
    }  
    .dp_view{
      display: none;
    }     
  }
      /* Large devices (laptops/desktops, 992px and up) */
      @media  only screen and (min-width: 992px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
      .sec_rect{
    display: none;
    }
        .mb_view{
      display: none;
    }
    
      }
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      @media  only screen and (min-width: 1200px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
  .sec_rect{
 display: none;
 }
 .mb_view{
  display: none;
 }
      }
      .footer-get-trial-button {
          background: #FDC031;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 6px;
          padding-bottom: 6px;
          font-weight: bold;
          border-radius: 4px;
          border: none;
          color: #333;
          text-align: center;
          margin-top: 10px;
          font-weight: 500;
          transition: all 0.5s;
          cursor: pointer;
      }
      .footer-hr {
          border-color: #404447;
          background-color: #404447;
          color: #404447;
      }
      .below-hr-container {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a:hover {
          text-decoration: none;
      }
  /* footer css end */

  /* faq section start */
/* faq's css start */
.vl {
    border-left: 1px solid rgb(202, 200, 200);
    height: 610px;
    
  }
  .accordion {
    max-width: 100%;
    margin: 50px auto 100px;
    /* border-top: 1px solid #d9e5e8; */
  }
  .accordion li {
    border-bottom: 1px solid #d9e5e8;
    position: relative;
  }
  .accordion li p {
    display: none;
    padding: 10px 25px 30px;
    color: #6b97a4;
  }
  .accordion a {
  
    width: 100%;
    display: block;
    cursor: pointer;
    font-weight: 700;
    line-height: 3;
    font-size: 15px;
    /* font-size: 0.875rem; */
    text-indent: 15px;
    user-select: none;
  }
  .accordion a:after {
    width: 8px;
    height: 8px;
    border-right: 1px solid #4a6e78;
    border-bottom: 1px solid #4a6e78;
    position: absolute;
    right: 10px;
    content: " ";
    top: 17px;
    transform: rotate(-45deg);
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  .accordion p {
    font-size: 14px;
    /* font-size: 0.8125rem; */
    line-height: 2;
    padding: 10px;
  }
  
  a.active:after {
    transform: rotate(45deg);
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
  }
  .faq_caption{
    margin-top:-540px
  } 
  /* faq section end */
  .sec_rect{
  background-color:white;
   background-attachment: fixed;
   background-repeat: no-repeat;
 background-attachment: fixed;
 }
</style>